import React from 'react'

import { Switch } from '@app/components/util'
import { LntButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'
import { EXTERNAL_PRODUCT_STATUS } from '@app/pages/ExternalProductsCatalogPage/сonstans'

import styles from './styles.module.scss'

import type { ProductCardDrawerFooterProps } from './types'

const { Case } = Switch

export const ProductCardDrawerFooter: React.FC<ProductCardDrawerFooterProps> = ({
  onClose,
  onShowConfirmedDrawer,
  formId,
  status
}) => {
  return (
    <Switch>
      <Case condition={ status === EXTERNAL_PRODUCT_STATUS.notConfirmed }>
        <div className={ styles.productCardDrawerFooter }>
          <LntButton
            type={ BUTTON_TYPE.secondary }
            size={ SIZE.middle }
            onClick={ onShowConfirmedDrawer }
          >
            Добавить к
          </LntButton>
          <LntButton
            type={ BUTTON_TYPE.secondary }
            size={ SIZE.middle }
            onClick={ onClose }
          >
            Отмена
          </LntButton>
          <LntButton
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            htmlType='submit'
            form={ formId }
          >
            Подтвердить
          </LntButton>
        </div>
      </Case>

      <Case
        condition={ status === EXTERNAL_PRODUCT_STATUS.confirmed || status === EXTERNAL_PRODUCT_STATUS.confirmedByLenta }
      >
        <div className={ styles.productCardDrawerFooter }>
          <LntButton
            type={ BUTTON_TYPE.secondary }
            size={ SIZE.middle }
            onClick={ onClose }
          >
            Отмена
          </LntButton>

          <LntButton
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            htmlType='submit'
            form={ formId }
          >
            Сохранить
          </LntButton>
        </div>
      </Case>
    </Switch>
  )
}
